import { Button, Color, Icon, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegment } from '../../../../hooks'
import { useOrganizationViewUrl } from '../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../utils/routing/reactRoute'
import { useIsDemoInvoiceEditorEnabled } from '../../hooks/useIsDemoInvoiceEditorEnabled'
import * as Styled from './styles'

export const DemoInvoiceTryCard = (): ReactElement | null => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const isDemoInvoiceEditorEnabled = useIsDemoInvoiceEditorEnabled()
  const { url: demoInvoiceUrl } = useOrganizationViewUrl(reactRoute.organization.demoInvoice.getMainRoute())

  const handleClick = useCallback(() => {
    track('XXX - Invoicing Core - Invoices List - Try the demo clicked', { entryPoint: 'invoices_list' })
  }, [track])

  if (!isDemoInvoiceEditorEnabled) {
    return null
  }

  return (
    <Styled.CardWrapper>
      <Styled.IconSquircle>
        <Icon color={Color.Black} icon="mousePointerClick" size="md" />
      </Styled.IconSquircle>
      <Styled.CardContent>
        <Text variant="h4" weight="semiBold">
          {t('demo_invoice.try_card.title')}
        </Text>
        <Text colorVariant="secondary" variant="bodyMD">
          {t('demo_invoice.try_card.description')}
        </Text>
      </Styled.CardContent>
      <Button icon="mousePointerClick" onClick={handleClick} to={demoInvoiceUrl} variant="tonal">
        {t('demo_invoice.try_card.button')}
      </Button>
    </Styled.CardWrapper>
  )
}
